<template>
	<v-row no-gutters>
		<v-col cols="12">
			<div class="edit-mode" style="position: relative; z-index: 3; background: #fcfcfd">
				<v-row no-gutters>
					<v-col cols="12">
						<v-row no-gutters class="align-center" style="position: relative; z-index: 3; height: 70px">
							<v-col cols="12">
								<v-row no-gutters class="fill-height align-center px-6" style="overflow: hidden">
									<v-col class="text-left" align="center" style="min-width: 250px; height: 70px; position: relative; overflow: hidden">
										<transition name="fromBottomLong" mode="out-in">
											<v-row no-gutters v-if="showParams" style="position: relative" class="fill-height align-center">
												<v-col class="text-left" cols="auto">
													<v-card class="ac_card integration inline-block">
														<div class="centerdXY">
															<SIcon :name="headerIcons || appInfo.service_slug" eager :width="23" />
														</div>
													</v-card>
												</v-col>

												<v-col class="pl-3">
													<input
														type="text"
														ref="bName"
														@click="editName"
														v-model="blockName"
														class="b_name_input"
														@focus="inputFocus"
														@blur="inputBlur"
														:class="{ focused: bNameFocus }"
													/>
													<div class="prof" v-if="currentProfile">
														{{ currentProfile }}
														<span style="color: rgba(41, 40, 41, 0.6) !important">({{ profileType }}) </span>
													</div>
													<div class="icon-edit">
														<SIcon
															name="edit-name"
															iconColor="#6B7786"
															style="left: -2px; transition-delay: 0.15s !important"
															:width="7"
														></SIcon>
													</div>
												</v-col>
											</v-row>
										</transition>
										<transition name="fromBottomLong" mode="out-in">
											<v-row no-gutters v-if="!showParams" style="height: 70px; line-height: 70px; position: relative">
												<v-col class="text-left" cols="auto" style="min-width: 250px" v-if="!showParams">
													<h2>Choose action</h2>
												</v-col>
											</v-row>
										</transition>
									</v-col>

									<v-col cols="2" class="right_actions text-right ml-auto">
										<transition name="fromRight">
											<AsyncIcon />
										</transition>
										<transition name="fromRight">
											<v-btn
												icon
												rounded
												style="background: transparent"
												small
												@click="showIntegration = !showIntegration"
												v-if="showParams && integrationSelector"
											>
												<v-icon style="color: #6b7786">mdi-chevron-{{ showIntegration ? 'up' : 'down' }}</v-icon>
											</v-btn>
										</transition>
									</v-col>
								</v-row>

								<v-row no-gutters v-if="showParams">
									<v-col cols="12">
										<v-divider></v-divider>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
			</div>
		</v-col>

		<div class="intg" :class="{ i_shown: showIntegration }">
			<v-row no-gutters justify="center" class="pt-5">
				<v-col cols="10">
					<BlockEditorIntegration @showSelectAppScreen="selectNewApp" />
				</v-col>
			</v-row>
		</div>
	</v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import AsyncIcon from './AsyncIcon';
import BlockEditorIntegration from './BlockEditorIntegration';

export default {
	name: 'BlockEditorTopHeader',
	components: {
		AsyncIcon,
		BlockEditorIntegration,
	},
	props: {
		showParams: { type: Boolean },
		integrationSelector: { type: Boolean, default: true },
		headerIcons: { type: String },
	},
	watch: {
		blockName: {
			handler(n) {
				this.localBlockName = n;
			},
			immediate: true,
		},
	},
	computed: {
		...mapGetters('selectedNode', ['editNode']),
		...mapGetters(['apps/getService', 'apps/getCredentialsForService', 'actions/getAction']),
		appInfo() {
			return this['apps/getService'](this.editNode.service) || { service_slug: 'default' };
		},
		profileType() {
			return 'Embedded';
		},
		currentProfile() {
			const o = this.profileItemsList.find((o) => o.id == this.editNode.credentials_configuration.credentials);
			if (!o) {
				return null;
			} else {
				return o.connection_name;
			}
		},
		profileItemsList() {
			return this['apps/getCredentialsForService'](this.editNode.service) || [];
		},
		blockName: {
			get() {
				if (!this.editNode) {
					return this.appInfo.service_name;
				}
				const action = this['actions/getAction'](this.editNode.action);
				if (this.editNameMode) {
					return this.localBlockName;
				}
				if (!this.editNode.node_title) {
					if (action) {
						return action.title;
					} else {
						return this.appInfo.service_name;
					}
				}
				return this.editNode.node_title;
			},
			set(value) {
				this.localBlockName = value;
				this.setParamInEditNode({ key: 'node_title', value });
			},
		},
	},
	methods: {
		...mapActions('selectedNode', ['setParamInEditNode']),
		selectNewApp() {
			this.$emit('showSelectAppScreen');
		},
		showSelectAppScreen() {},
		inputLeave() {
			this.$refs.bName.blur();
		},
		inputBlur() {
			this.bNameFocus = false;
			this.editNameMode = false;
		},
		inputFocus() {
			this.bNameFocus = true;
		},
		editName() {
			this.editNameMode = true;
			this.$refs.bName.focus();
		},
	},
	data: () => ({
		showIntegration: false,
		localBlockName: '',
		editNameMode: false,
		bNameFocus: false,
		showTop: false,
	}),
};
</script>

<style scoped lang="scss">
.edit-mode {
	position: relative;

	.icon-edit {
		position: absolute;
		right: 7px;
		top: 10px;
		opacity: 0;
		transition: 0.3s;
	}
	::v-deep .b_name_input {
		border-bottom: 1px rgba(0, 0, 0, 0) dashed;
		transition: 0.5s;
	}

	&:hover {
		.icon-edit {
			opacity: 1;
			transition: 0.6s;
		}
		::v-deep .b_name_input {
			border-bottom: 1px rgba(0, 0, 0, 0.2) dashed;
			transition: 1s;
		}
	}
}
.b_name_input {
	width: 100%;
	height: 20px;
	color: #292829;
	font-weight: 600;
	font-size: 19px;
	text-overflow: ellipsis;
	cursor: pointer;
}
.b_name_input.focused {
	cursor: auto;
}
input:focus {
	outline: none;
}
.b_name_input.focused {
	color: #5b8bc6 !important;
}
.ac_card {
	border-radius: 7px !important;
	border-color: #d6ddeb;
	width: 42px;
	height: 42px;
}
.b_name {
	cursor: pointer;
}
.e_btn {
	opacity: 0;
}
.inf:hover .e_btn {
	opacity: 1;
}
.intg {
	width: 100%;
	text-align: center;
	background: #fcfcfd;
	height: auto;
	position: absolute;
	border-bottom-left-radius: 22px;
	border-bottom-right-radius: 22px;
	z-index: 2;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
	transform: translateY(-110%);
	opacity: 0;
	transition: all 0.3s;
}
.prof {
	color: #292829;
	font-size: 12px;
	font-weight: 300;
}
.inf {
	line-height: 16px;
	font-weight: 300;
	height: 40px;
}
.inf .b_name {
	opacity: 1;
	font-size: 20px;
	font-weight: 600;
}
.params_cont {
	position: relative;
	width: 100%;
}
.form_w {
	position: relative;
	overflow: hidden;
}
.form_cont {
	position: relative;
	z-index: 1;
	min-height: 0px;
}

.intg {
	width: 100%;
	text-align: center;
	background: #fcfcfd;
	height: auto;
	position: absolute;
	border-bottom-left-radius: 22px;
	border-bottom-right-radius: 22px;
	z-index: 2;
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
	transform: translateY(-100%);
	opacity: 0;
	transition: all 0.3s;
	top: 70px;
	padding-bottom: 20px;
}
.intg.i_shown {
	transform: translateY(0) !important;
	opacity: 1 !important;
}
</style>
